export function _getWorkshopCode(code) {
  switch (code) {
    case 1:
      return  'Rotor';
    case 2:
      return 'Machining';
    case 3:
      return 'Packing';
    case 4:
      return 'Testing';
    default:
      return 'SITH';
  }
}